





































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NumberField extends Vue {
  @Prop(String) public label;
  @Prop({ type: String, default: '' }) public readonly info!: string;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop() public readonly rules!: any;
  @Prop(String) public readonly labelCols!: string;
  @Prop(String) public readonly inputCols!: string;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop(String) public readonly prefix!: string;
  @Prop(String) public readonly suffix!: string;
  @Prop({ type: Number, default: 2 }) public readonly precision!: number;
  @Prop({ type: Number, default: undefined }) public readonly minValue!: number;
  @Prop({ type: Number, default: undefined }) public readonly maxValue!: number;

  public dataValue: null | number = this.rec[this.field];
  public textValue: string = this.formatDataValue(this.dataValue);

  public formatDataValue(v) {
    if (v != null) {
        return Vue.filter('number')(v);
    }
    return '';
  }

  public parseTextValue(v) {
    return parseFloat(v.replace(/,/g, '.'));
  }

  public synchronizeText() {
    const text = this.formatDataValue(this.dataValue);
    // console.log('NumberField.synchronizeText0', this.dataValue, text, this.textValue, this.textValue !== text);
    if (this.textValue !== text) {
      this.textValue = text;
      // console.log('NumberField.synchronizeText', this.textValue);
    }
  }

  public textInput(newInput) {
    // console.log('NumberField.textInput', this.textValue, newInput);
    if (this.textValue) {
      this.dataValue = this.parseTextValue(this.textValue);
      this.synchronizeText();
    } else {
      this.dataValue = null;
    }
    if (this.dataValue !== this.rec[this.field]) {
      this.rec[this.field] = this.dataValue;
      this.$emit('change', this.dataValue);
    }
  }
  public textChange(e) {
    // console.log('NumberField.textChange', this.textValue, e);
  }
  public textEnter(e) {
    // console.log('NumberField.textEnter', e);
    // this.synchronizeText();
    this.$emit('enter', e);
  }
  public textBlur(e) {
    // console.log('NumberField.textBlur', e);
    // this.synchronizeText();
    this.$emit('blur', e);
  }
  public created() {
    this.$watch(
      function() { return this.rec[this.field]; },
      function(newValue, oldValue) {
          // console.log('NumberField.$watch', oldValue, '->',  newValue);
          if (oldValue !== newValue) {
            this.dataValue = newValue;
            this.textValue = this.formatDataValue(this.dataValue);
          }
        }
    );
  }
}
